var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7304_75780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7304_75780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91927 12.25C2.75399 12.25 2.61545 12.1941 2.50365 12.0823C2.39184 11.9705 2.33594 11.8319 2.33594 11.6667C2.33594 11.5014 2.39184 11.3628 2.50365 11.251C2.61545 11.1392 2.75399 11.0833 2.91927 11.0833H11.0859C11.2512 11.0833 11.3898 11.1392 11.5016 11.251C11.6134 11.3628 11.6693 11.5014 11.6693 11.6667C11.6693 11.8319 11.6134 11.9705 11.5016 12.0823C11.3898 12.1941 11.2512 12.25 11.0859 12.25H2.91927ZM4.66927 9.91667C4.0276 9.91667 3.4783 9.68819 3.02135 9.23125C2.56441 8.77431 2.33594 8.225 2.33594 7.58333V2.91667C2.33594 2.59583 2.45017 2.32118 2.67865 2.09271C2.90712 1.86424 3.18177 1.75 3.5026 1.75H11.6693C11.9901 1.75 12.2648 1.86424 12.4932 2.09271C12.7217 2.32118 12.8359 2.59583 12.8359 2.91667V4.66667C12.8359 4.9875 12.7217 5.26215 12.4932 5.49062C12.2648 5.7191 11.9901 5.83333 11.6693 5.83333H10.5026V7.58333C10.5026 8.225 10.2741 8.77431 9.81719 9.23125C9.36024 9.68819 8.81094 9.91667 8.16927 9.91667H4.66927ZM10.5026 4.66667H11.6693V2.91667H10.5026V4.66667Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.dc3f660e841de52357f693891093ab98.svg";
export { ForwardRef as ReactComponent };